

export default [
    {
        path: 'solution',
        component: resolve => require(['@/views/solution'], resolve),
        name: 'Solution',
        meta: {
            nav: '解决方案'
        }
    }
      
]


// WEBPACK FOOTER //
// ./src/router/solution.js